var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504 504",
    xmlSpace: "preserve",
    width: "70px",
    height: "70px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#29a383"
    },
    cx: 252,
    cy: 252,
    r: 252
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19e6ac"
    },
    d: "M51.9,405.1C97.9,465.2,170.4,504,252,504s154.1-38.8,200.1-98.9H51.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.4,
    y: 174.2,
    style: {
      fill: "#d9dbde"
    },
    width: 265.3,
    height: 231.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 128.7,
    style: {
      fill: "#fdfcfc"
    },
    width: 174.9,
    height: 277
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 391.4,
    style: {
      fill: "#324A5E"
    },
    width: 309.9,
    height: 14.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 150.2,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 150.2,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.2,
    y: 150.2,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.5,
    y: 150.2,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 192.9,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 192.9,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.2,
    y: 192.9,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.5,
    y: 192.9,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 235.6,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 235.6,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.2,
    y: 235.6,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.5,
    y: 235.6,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 278.2,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 278.2,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.2,
    y: 278.2,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.5,
    y: 278.2,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 320.9,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 320.9,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.2,
    y: 320.9,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.5,
    y: 320.9,
    style: {
      fill: "#CED5E0"
    },
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E23428"
    },
    points: "252,57.6 261.4,76.7 282.5,79.8 267.2,94.7 270.8,115.6 252,105.7 233.2,115.6 236.8,94.7 221.5,79.8 242.6,76.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E23428"
    },
    points: "312.7,72.8 318.7,85 332.2,86.9 322.5,96.5 324.8,109.9 312.7,103.6 300.6,109.9 302.9,96.5 293.2,86.9 306.7,85 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E23428"
    },
    points: "358.3,86.6 362,94.3 370.5,95.5 364.4,101.5 365.8,109.9 358.3,105.9 350.7,109.9 352.1,101.5 346,95.5 354.5,94.3 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E23428"
    },
    points: "191.3,72.8 185.3,85 171.8,86.9 181.5,96.5 179.2,109.9 191.3,103.6 203.4,109.9 201.1,96.5 210.8,86.9 197.3,85 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E23428"
    },
    points: "145.7,86.6 142,94.3 133.5,95.5 139.6,101.5 138.2,109.9 145.7,105.9 153.3,109.9 151.9,101.5 158,95.5 149.5,94.3 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 357.5,
    style: {
      fill: "#E23428"
    },
    width: 64.3,
    height: 33.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 192.9,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 232.4,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 272,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 311.5,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.6,
    y: 351.1,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.7,
    y: 192.9,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.7,
    y: 232.4,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.7,
    y: 272,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.7,
    y: 311.5,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.7,
    y: 351.1,
    style: {
      fill: "#4CDBC4"
    },
    width: 19.7,
    height: 21.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHotel);
export default __webpack_public_path__ + "static/media/logo-hotel.888c49f317b7b1fc099fb617b669835e.svg";
export { ForwardRef as ReactComponent };